var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Register for the event here")]),_c('button',{on:{"click":_vm.register}},[_vm._v("Register Me")])])}
var staticRenderFns = []

export { render, staticRenderFns }